(function () {
  // Persists across AJAX re-renders; keyed by section ID so multi-section pages work
  var TOUCHED = {};

  function initVzSize(root) {
    if (root.dataset.vzSizeInit) return;
    root.dataset.vzSizeInit = '1';

    var trigger     = root.querySelector('[data-vz-size-trigger]');
    var panel       = root.querySelector('[data-vz-size-panel]');
    var native      = root.querySelector('[data-vz-size-native]');
    var placeholder = root.querySelector('[data-vz-size-placeholder]');
    var valueEl     = root.querySelector('[data-vz-size-value]');
    var currentEl   = root.querySelector('[data-vz-size-current]');
    var lowBadge    = root.querySelector('[data-vz-size-low]');
    var lowCount    = root.querySelector('[data-vz-size-low-count]');

    if (!trigger || !panel || !native) return;

    var sectionId = native.dataset.template || 'main';
    var formId    = native.getAttribute('form');
    var form      = formId ? document.getElementById(formId) : native.closest('form');

    function getCells() { return root.querySelectorAll('[data-vz-size-cell]'); }
    function isSelected() { return !!root.querySelector('.vz-size__cell.is-selected'); }

    function showPlaceholder() {
      if (placeholder) placeholder.hidden = false;
      if (valueEl)     valueEl.hidden     = true;
      if (lowBadge)    lowBadge.hidden    = true;
      getCells().forEach(function (c) { c.classList.remove('is-selected'); });
      native.selectedIndex = -1;
    }

    function applyValue(text, stock) {
      if (placeholder) placeholder.hidden = true;
      if (valueEl)     valueEl.hidden     = false;
      if (currentEl)   currentEl.textContent = text;
      if (lowBadge) {
        if (stock > 0 && stock <= 3) {
          if (lowCount) lowCount.textContent = stock;
          lowBadge.hidden = false;
        } else {
          lowBadge.hidden = true;
        }
      }
    }

    // After AJAX re-render the Liquid marks the previously-picked cell is-selected —
    // read it to restore the trigger label without resetting the picker
    function restoreFromSelected() {
      var cell = root.querySelector('.vz-size__cell.is-selected');
      if (!cell) { showPlaceholder(); return; }
      var label = cell.querySelector('.vz-size__cell-value');
      var text  = label ? label.textContent.trim() : (cell.dataset.display || '');
      applyValue(text, parseInt(cell.dataset.stock, 10));
    }

    function shakeError() {
      trigger.classList.add('vz-size__trigger--error');
      trigger.addEventListener('animationend', function onEnd() {
        trigger.classList.remove('vz-size__trigger--error');
        trigger.removeEventListener('animationend', onEnd);
      });
    }

    function selectCell(cell) {
      if (cell.dataset.available !== 'true') return;
      TOUCHED[sectionId] = true;
      getCells().forEach(function (c) { c.classList.remove('is-selected'); });
      cell.classList.add('is-selected');
      var label = cell.querySelector('.vz-size__cell-value');
      var text  = label ? label.textContent.trim() : (cell.dataset.display || '');
      applyValue(text, parseInt(cell.dataset.stock, 10));
      native.value = cell.dataset.value;
      native.dispatchEvent(new Event('change', { bubbles: true }));
      setTimeout(closePanel, 200);
    }

    function openPanel()  { panel.hidden = false; trigger.setAttribute('aria-expanded', 'true');  }
    function closePanel() { panel.hidden = true;  trigger.setAttribute('aria-expanded', 'false'); }

    // Block form submit when no size is selected
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!isSelected()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          openPanel();
          shakeError();
        }
      });
    }

    trigger.addEventListener('click', function () {
      if (panel.hidden) openPanel(); else closePanel();
    });

    getCells().forEach(function (cell) {
      cell.addEventListener('click', function () { selectCell(cell); });
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) closePanel();
    });

    // First load → placeholder (on.com behavior: user must actively pick a size)
    // After AJAX re-render and user already touched → restore their selection
    if (TOUCHED[sectionId]) {
      restoreFromSelected();
    } else {
      showPlaceholder();
    }
  }

  function initAll() {
    document.querySelectorAll('[data-vz-size]').forEach(initVzSize);
  }

  // Re-init after theme AJAX re-renders (.f8pr-variant-selection replacement)
  var observer = new MutationObserver(function (mutations) {
    var needsInit = false;
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1 && (
          (node.classList && node.classList.contains('f8pr-variant-selection')) ||
          (node.querySelector && node.querySelector('[data-vz-size]'))
        )) needsInit = true;
      });
    });
    if (needsInit) setTimeout(initAll, 50);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function () {
    // Theme editor reload — reset touched state so placeholder shows again
    document.querySelectorAll('[data-vz-size]').forEach(function (el) {
      delete el.dataset.vzSizeInit;
    });
    TOUCHED = {};
    initAll();
  });
})();
